import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { Column } from '../Layout';
import { animated } from 'react-spring';

export const PressHeader = styled(Column)`
  display: none;
  ${mediaQueries.tablet} {
    display: block;
  }
`;

export const LoadMoreButtonWrapper = styled('div')`
  text-align: center;
`;

interface Props {
  hidden: boolean;
  firstPressItem: boolean;
}

export const HiddenBox = styled(animated.div, {
  shouldForwardProp: (prop) => prop !== 'firstPressItem'
})<Props>`
  display: ${({ hidden }) => (hidden ? 'none' : 'block')};
  margin: ${({ theme, firstPressItem }) =>
    firstPressItem ? `0` : `${theme.spacing.l} 0}`};

  ${mediaQueries.tablet} {
    margin: ${({ theme }) => `${theme.spacing.masonryGutter} 0}`};
  }
  ${mediaQueries.desktop} {
    margin: ${({ theme }) => `${theme.spacing.m} 0 ${theme.spacing.xl} 0}`};
  }
`;
